import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import setToast from "../../helpers/toaster.helper";
import { FalconLogo } from "../../icon";
import * as selector from "../../selectors/selectors";
import { AuthService } from "../../services/AuthService";
import { UserService } from "../../services/UserService";
import UnAuthComponent from "../layout/unauth.component";
import { AppRoutes } from "../routes/route.path";
import { ToasterTexts, appNote, buttonLabels } from "../shared/constants";
import { ToasterType } from "../shared/toaster/toaster.model";
import TwofactorAuthenticationForm from "../shared/twofactor-authentication-form.component";

interface Props { }

const TwoFactorAuthentication = (props: Props) => {
    const navigate = useNavigate();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const PageRef = useRef<HTMLDivElement>()

    const [userinput, setUserinput] = useState<{
        isValid: boolean;
        value: string;
        showErrorMsg: string;
        countError: number;
        ShowResendTimer: boolean;
        IsLoading: boolean;
    }>({
        isValid: true,
        value: "",
        showErrorMsg: "",
        countError: 0,
        ShowResendTimer: true,
        IsLoading: false,
    })

    useEffect(() => {
        const element = PageRef.current;
        if (element) {
            element.addEventListener('keydown', handleArrowNavigation);
        }

        return () => {
            const element = PageRef.current;
            if (element) {
                element.removeEventListener('keydown', handleArrowNavigation);
            }
        }
    })

    const handleArrowNavigation = (e: any) => {
        const active = document.activeElement;
        let index: any;

        if (active && e.keyCode === 37) {
            index = active.getAttribute('data-left-arrow-index') || active.getAttribute('data-arrow-index');
            (document.querySelector(`[data-arrow-index="${index}"]`) as any)?.focus();
        }
        else if (active && e.keyCode === 38) {
            index = active.getAttribute('data-up-arrow-index') || active.getAttribute('data-arrow-index');
            (document.querySelector(`[data-arrow-index="${index}"]`) as any)?.focus();
        }
        else if (active && e.keyCode === 39) {
            index = active.getAttribute('data-right-arrow-index') || active.getAttribute('data-arrow-index');
            (document.querySelector(`[data-arrow-index="${index}"]`) as any)?.focus();
        }
        else if (active && e.keyCode === 40) {
            index = active.getAttribute('data-down-arrow-index') || active.getAttribute('data-arrow-index');
            (document.querySelector(`[data-arrow-index="${index}"]`) as any)?.focus();
        }
    }

    const verifyOtp = (event: any) => {
        event.preventDefault();
        const otpPin = userinput.value;
        setUserinput({ ...userinput, IsLoading: true })
        UserService.verifyTwoFactAuth(otpPin)
            .then((res) => {
                if (res.status === 200) {
                    setUserinput({ ...userinput, showErrorMsg: "", isValid: true, countError: 0, IsLoading: false });
                    localStorage.setItem("2FAVerified", "true");
                    UserService.getCurrentUser().then((res: any) => {
                        if (!!res.data && !res.data.lastLoggedIn) {
                            navigate(AppRoutes.RESET_PASSWORD_NEW);
                        }
                        else {
                            navigate(UserService.hasSysAdminRole() ? AppRoutes.PHONE_NUMBERS : IsMobileDevice ? AppRoutes.CONVERSATIONS : AppRoutes.DASHBOARD);
                            window.location.pathname.includes("teams") && navigate(0);
                        }
                    });
                }
            })
            .catch((error) => {
                localStorage.setItem("2FAVerified", "false");
                setUserinput({ ...userinput, IsLoading: false })
                setUserinput({ ...userinput, showErrorMsg: error.response.data.message, countError: userinput.countError + 1 })

                if (userinput.countError >= 2) {
                    localStorage.clear();
                    setUserinput({ ...userinput, isValid: false, IsLoading: false });
                }

            })
    };

    const handleChange = (otp: any) => {
        setUserinput({ ...userinput, value: otp });
    };

    const resendOtp = () => {
        setUserinput({ ...userinput, ShowResendTimer: false })
        UserService.sendTwoFactAuthPin().then((res) => {
            setToast(ToasterTexts.RESEND_OTP_SUCCESS, ToasterType.SUCCESS);
            setUserinput({ ...userinput, ShowResendTimer: true })
        }).catch((err) => {
            setToast(ToasterTexts.RESEND_OTP_FAILURE, ToasterType.DANGER);
        });
    };

    useEffect(() => {
        if (!!AuthService.loggedIn() && !!AuthService.is2FACompleted() && !!AuthService.isNewUser()) {
            navigate(AppRoutes.RESET_PASSWORD_NEW);
        }
        else if (!!AuthService.loggedIn() && !AuthService.is2FACompleted()) {
            navigate(AppRoutes.TWO_FACTOR_AUTHENTICATION);
        }
        else if (!!AuthService.isUserLoggedIn()) {
            navigate(UserService.hasSysAdminRole() ? AppRoutes.PHONE_NUMBERS : IsMobileDevice ? AppRoutes.CONVERSATIONS : AppRoutes.DASHBOARD);
        }
        else {
            navigate(AppRoutes.SIGN_IN);
            localStorage.clear();
        }
    }, [])

    return (
        <div style={{ zIndex: 10000 }} className={`mx-auto ${IsMobileDevice ? "h-p-100" : "h-p-100"} d-flex flex-direction w-p-100  align-center tooltip-z-index`} ref={PageRef}>
            <div className={"d-flex h-p-20 w-p-100 align-center pl-15"}>
                <FalconLogo className="" />
            </div>
            <div className="w-p-70 max-w-70 h-p-60 d-flex flex-direction justify-center align-center">
                <TwofactorAuthenticationForm
                    StepLength={1}
                    NumOfSteps={4}
                    IsNumberInput={true}
                    HandleOnChangeStepValue={handleChange}
                    Value={userinput.value}
                    ErrorMessage={userinput.showErrorMsg}
                    ResendOtp={resendOtp}
                    VerifyOtp={verifyOtp}
                    IsValid={userinput.isValid}
                    ResendLabel={"Resend OTP"}
                    ShowResendTimer={userinput.ShowResendTimer}
                    ResendTime={30}
                    Title={"Enter the 4 digit OTP received on your email ID"}
                    IsLoading={userinput.IsLoading}
                    WrongAttemptsDisplayMsg={appNote.TWOFACTORAUTH_ERROR}
                    WrongAttemptsBtnLabel={buttonLabels.BACK_TO_HOME}
                    WrongAttemptsBtnPath={AppRoutes.HOME_PATH}
                    IsUnAuthScreen
                    OtpTextFieldColor={"bg-color-unauth-field"}
                    IsBackTologin
                />
            </div>
        </div>
    );
}

export default UnAuthComponent(TwoFactorAuthentication);